<template>
    <v-container fluid>
       
        <v-layout row wrap>        
            <v-flex xs12>
                <h2> Markenübersicht </h2>
            </v-flex>

        </v-layout>

        <v-container fluid grid-list-xs fill-height>
            <v-layout row wrap fill-height>
                 
                <v-flex xs12 md6 lg4 v-for="marke in filteredMarken" v-bind:key="marke.id">                         
                    <single-marken v-on:toDestroy="onDestroy(marke.id)" v-bind:mk="marke"></single-marken>
                </v-flex> 
                
            </v-layout>
        </v-container>
        
   </v-container>
</template>

<script>

import searchMixin from '../../mixins/searchMixin'
import singleMarken from './singleMarken.vue'


export default {
    
    components: {
        'single-marken': singleMarken,
        
        
    },    
    created: function(){
        this.$store.dispatch('setMarken')
    },
    
    computed: {
        
        marken: function() {
            return this.$store.getters.marken;
        },
        loading: function() {
            return this.$store.getters.loading
        }
    },
    methods: {
        
        onDestroy: function(id) {            
            this.$store.commit('setMessagebar', false)             
            this.$store.dispatch('deleteMarke', id)
            .then(()=>{                
                this.$store.dispatch('setPreFilteredMarken',[])
                this.$store.dispatch('setPreFilteredFirmen',[])                
            }).catch((error)=>{
                console.log(error)
                
            })     
            this.$store.commit('setMessagebar', true)
        },
        
    },
       
    mixins: [
        searchMixin
    ]
    
}
</script>

<style>
    
    
    
</style>



// WEBPACK FOOTER //
// showMarken.vue?4c94cf74